// Gated pages — hidden from the dashboard + blocked by route guard unless the
// user is a super admin (full access) or has the key granted on the Admin Users
// page (EMPLOYEES.page_access). Keep `key` in sync with the backend
// GATED_PAGE_KEYS (BFA/utils/page-access.js) and the bfav5 registry.
import { Employee } from '../types/backend.types';

export const GATED_PAGE_KEYS = ['trucks', 'shop-todo'];

export function canAccessPage(user: Employee | null | undefined, key: string): boolean {
  if (!user) return false;
  if (user.is_super_admin) return true;
  return Array.isArray(user.page_access) && user.page_access.includes(key);
}
